/* eslint-disable indent */

export default {
    selectedLocale: 'en',
    locales: '',
    translations: '',
};
